import { NEED_USER_INPUT_TO_PROCEED_KEY, useData } from "@Utils";

type INeedUserInputToProceedData = {
    needUserInputToProceed: boolean;
    messageForUserToProceed?: string;
};

const DEFAULT_VALUE: INeedUserInputToProceedData = {
    needUserInputToProceed: false,
};

export const useNeedUserInputToProceed = () => {
    const {
        data: needUserInputToProceedData = DEFAULT_VALUE,
        setData: setNeedUserInputToProceedData,
    } = useData<INeedUserInputToProceedData>(
        NEED_USER_INPUT_TO_PROCEED_KEY,
        DEFAULT_VALUE
    );

    return {
        needUserInputToProceedData,
        allowUserToProceed: () => {
            setNeedUserInputToProceedData(DEFAULT_VALUE);
        },
        dontAllowUserToProceed: ({
            messageForUserToProceed = "",
        }: {
            messageForUserToProceed?: string;
        }) => {
            setNeedUserInputToProceedData({
                needUserInputToProceed: true,
                messageForUserToProceed,
            });
        },
    };
};
